import axiosJava from "@/api/config_java";
// import qs from 'qs'

//媒体账户充值记录表
export const getMediaPlatformList = param => axiosJava.get(`/am/api/accountFunds/list`, { params: param });

//充值审核
export const examineAccountFunds = param => axiosJava.post(`/am/api/accountFunds/examine`, param);

//获取充值是否需要审核
export const getRechargeExamineStatus = param => axiosJava.post(`/am/api/accountFunds/getRechargeExamineStatus`, param);

//媒体账户充值记录表导出
export const getMediaPlatformExport = param =>
  axiosJava.get(`/am/api/recharge/export?${param}`, {
    responseType: "blob"
  });

//媒体账户充值记录表详情
export const getMediaPlatformDetail = param =>
  axiosJava.get(`/am/api/recharge/details`, { params: param });

//FB账户拨款申请记录
export const getAppropriationList = param =>
  axiosJava.get(`/am/api/appropriation/list`, { params: param });

//拨款详情
export const getAppropriationDetail = id =>
  axiosJava.get(`/am/api/appropriation/details?id=${id}`);

//拨款导出
export const getAppropriationExport = param =>
  axiosJava.get(`/am/api/appropriation/export?${param}`, {
    responseType: "blob"
  });

// 汇款单上传
export const orderUpload = param =>
  axiosJava.post(`/am/api/file/upload`, param);